/**
 * @module trends.transformer
 * contain transformer for trends tab related rating measurements
 * As trends might be separated out to it's own section
 * so keep rating measurement entity generated by this trends transformer as trendRatingMeasurement
 */
import { nanoid } from '@reduxjs/toolkit';

const trendSurveyDatasetFrom = (dataset, index, identities) => {
  if (identities.group === 'timeframe') {
    return {
      ...identities,
      id: nanoid(8),
      position: index,
      selectedTimeframeIndex: dataset.selectedTimeframeIndex,
      label: dataset.label,
      percentFavorable: dataset.percentFavorable ?? 0,
      percentNeutral: dataset.percentNeutral ?? 0,
      percentUnfavorable: dataset.percentUnfavorable ?? 0,
      scoreAverage: dataset.scoreAverage ?? 0,
      enpsScore: dataset.enpsScore ?? null,
      countFavorable: dataset.countFavorable ?? 0,
      countNeutral: dataset.countNeutral ?? 0,
      countUnfavorable: dataset.countUnfavorable ?? 0,
    };
  }

  return {
    ...identities,
    id: nanoid(8),
    position: index,
    surveys: dataset.ids,
    label: dataset.label,
    percentFavorable: dataset.percentFavorable ?? 0,
    percentNeutral: dataset.percentNeutral ?? 0,
    percentUnfavorable: dataset.percentUnfavorable ?? 0,
    scoreAverage: dataset.scoreAverage ?? 0,
    enpsScore: dataset.enpsScore ?? null,
    countFavorable: dataset.countFavorable ?? 0,
    countNeutral: dataset.countNeutral ?? 0,
    countUnfavorable: dataset.countUnfavorable ?? 0,
  };
};

const trendMeasurementsFrom = (trends, group, type) => {
  if (!trends) return [];
  return trends.reduce((measurements, trend) => {
    const identities = {
      categoryId: type === 'factors' ? trend.id : trend.factorId,
      questionId: type === 'factors' ? null : trend.id,
      type,
      group,
    };
    const ratingMeasurements = trend.datasets.map((measurement, index) =>
      trendSurveyDatasetFrom(measurement, index, identities),
    );
    return [...measurements, ...ratingMeasurements];
  }, []);
};

const trendsRatingMeasurementsFrom = (measurements, group) => {
  const { factors, questions } = measurements;
  const factorMeasurements = trendMeasurementsFrom(factors, group, 'factors');
  const questionMeasurements = trendMeasurementsFrom(questions, group, 'questions');
  return [...factorMeasurements, ...questionMeasurements];
};

export { trendsRatingMeasurementsFrom };
